<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Recurring Payments</div>
  <div class="inner-card d-flex flex-column gap-4">
    <div class="title-sm">
      <span *ngIf="isMonthly" i18n>Monthly Payments</span>
      <span *ngIf="!isMonthly" i18n>Annual Payments</span>
    </div>
    <ng-container *ngFor="let row of rows; let last = last">
      <div class="payment-row">
        <div class="paragraph-lg">{{ row.jurisdictionName }}</div>
        <div class="amount-cell">
          <div class="row-amount">
            <span>{{ row.amount | currency }}</span
            ><span *ngIf="isMonthly" i18n class="period"> /mo</span
            ><span *ngIf="!isMonthly" i18n class="period"> /yr</span>
          </div>
          <div class="payment-type-label">{{ row.paymentTypeLabel }}</div>
        </div>
      </div>
      <hr *ngIf="!last" class="m-0" />
    </ng-container>
    <hr class="m-0" />
    <div class="d-flex flex-column gap-2">
      <div class="payment-row">
        <span i18n class="title-sm">Estimated Recurring Payments Total:</span>
        <div class="total-amount">
          <span>{{ total | currency }}</span
          ><span *ngIf="isMonthly" i18n class="period"> /mo</span
          ><span *ngIf="!isMonthly" i18n class="period"> /yr</span>
        </div>
      </div>
      <div *ngIf="isMonthly" class="payment-row">
        <span i18n class="annual-total-label">Est. Recurring Payments Annual Total</span>
        <div class="annual-total-value">
          <span>{{ annualTotal | currency }}</span>
          <span i18n> /yr</span>
        </div>
      </div>
    </div>
  </div>
</div>
